import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-no-pharmacies',
  imports: [RouterLink],
  templateUrl: './no-pharmacies.html',
  styleUrl: './no-pharmacies.scss',
})
export class NoPharmacies {}
